import qs from 'qs'
import axios from '@/api/apiClient'
import { deepClone } from '@/utils/util'
/**
 *  数据跟踪api
 */
const api = {
  TrackViewData: '/api/track/save',
  TrackViewUpdate: '/api/track/updateDuration',
  TrackForwardCompanyData: '/api/track/forward',
  TrackShareCreate: '/api/share/create',
}
export default api
/**
 * 获取跟踪数据所有模块id
 * @required {Number} actionType 1查看；2转发；3点赞
 * @returns moduleId
 */
export const getTrackBaseModule = (actionType) => {
  if (!actionType) {
    return
  }
  return axios.$get(`/api/track/modules/${actionType}`)
}
/**
 * 查看信息录入
 * @required {Number} param.moduleId 使用模块接口返回的moduleId
 * @param {Number} param.browseDuration 浏览时长
 * @param {String} param.bizUnicode 对应模块code(例：查看某个展品,则传入展品code)
 * @param {String} param.bizId 对应模块id(例：查看某个展品,则传入展品id)
 * @required {String} param.targetMemberCode 被查看、转发的用户code
 * @param {Number} param.remindStatus 是否提醒用户更新对应内容 1已提醒 -1 未提醒
 */
export const postTrackViewData = (param) => {
  return axios.$post(`${api.TrackViewData}`, param)
}
/**
 * 查看信息更新
 * @required {Number} param.moduleId 使用模块接口返回的moduleId
 * @param {Number} param.browseDuration 浏览时长
 * @param {Number} param.viewSaveId 查看录入ID
 */
export const putTrackViewDataUpdate = (param) => {
  return axios.$put(`${api.TrackViewUpdate}`, param)
}
/**
 * 转发行为企业数据记录(直接复制URL)【废弃】
 * @required {Number} param.moduleId 使用模块接口返回的moduleId
 * @param {String} param.bizUnicode 对应模块code(例：查看某个展品,则传入展品code)
 * @param {String} param.bizId 对应模块id(例：查看某个展品,则传入展品id)
 * @required {String} param.targetMemberCode 被查看、转发的用户code
 * @param {Number} param.shareParam 转发的内容参数
 */
// export const getTrackForwardCompanyData = (param) => {
//   return axios.$post(`${api.TrackForwardCompanyData}`, param)
// }

/**
 * 主动分享
 * @required {Number} param.shareChannel 分享类型  webchat_friend:微信好友 webchat_dynamic:微信朋友圈 html5:分享到h5
 * @param {String} param.shareType 分享渠道
 * @param {String} param.shareParam 分享内容的unicode
 * @required {String} param.targetMemberCode 被查看、转发的用户code
 */
export const postTrackShareCreate = (param) => {
  const params = deepClone(param)
  return axios.$get(`${api.TrackShareCreate}${params ? `?${qs.stringify(params)}` : ''}`)
}
